module.exports = require("react-native-svg");